module.exports = __webpack_public_path__ + "statics/img/5-1.48a832b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/5-1.png
// module id = mzIA
// module chunks = 1